import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {CashReport} from "../model/cashReport";
import {CashReportService} from "../service/cashReport.service";

@Injectable()
export class CashReportResolve implements Resolve<CashReport> {
    constructor(private cashReportService: CashReportService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<CashReport> {
        return this.cashReportService.getById(route.params.id);
    }
}